<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start" class="with-badge">
      <ion-menu-button />
      <ion-badge class="burger-badge" *ngIf="burgerBadge as badge">{{ badge }}</ion-badge>
    </ion-buttons>

    <ion-segment [(ngModel)]="segments" mode="md">
      <ion-segment-button value="jour" mode="ios" (click)="segmentAction()" layout="icon-start">
        <ion-icon size="small" color="light" name="day"></ion-icon>
        <ion-label>JOUR</ion-label>
      </ion-segment-button>
      <ion-segment-button value="semaine" mode="ios" (click)="segmentAction()" layout="icon-start">
        <ion-icon size="small" color="light" name="week"></ion-icon>
        <ion-label>SEMAINE</ion-label>
      </ion-segment-button>
    </ion-segment>

    <ion-buttons slot="end">
      <ion-button *ngIf="segments === 'jour'" [disabled]="loading()" (click)="openCalendarModal()">
        <ion-icon name="calendar-outline"></ion-icon>
      </ion-button>
      @if (showSearchbar()) {
        <ion-button (click)="toogleToolbar()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      } @else {
        <ion-button [disabled]="loading()" (click)="toogleToolbar()">
          <ion-icon name="search"></ion-icon>
        </ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
  @if (showSearchbar()) {
    <div color="primary" class="searchTool">
      <ion-title class="search">
        <div>
          <span>{{ 'GLOBAL.RECHERCHE' | translate }}</span>
        </div>
      </ion-title>
    </div>
  }
  <ion-toolbar color="white">
    <div class="week_number" slot="start">S{{ week }}</div>
    <today-pastille
      [fill]="todayInSelectedDates()"
      (pastilleClicked)="onPastilleClicked()"
      slot="start"
    ></today-pastille>
    <div class="dates_selector">
      <ion-button fill="clear" icon-only (click)="previous()" [disabled]="loading() || disableNavigateToPreviousTime">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
      @if (segments === 'jour') {
        <span class="date" [ngClass]="{ todayDate: todayInSelectedDates() }">
          {{ selectedDate | date: 'EEEE dd MMM' }}
        </span>
      } @else {
        <span class="date">{{ startOfWeek | date: 'd/M' }} au {{ endOfWeek | date: 'd/M' }}</span>
      }
      <ion-button fill="clear" icon-only (click)="next()" [disabled]="loading() || disableNavigateToNextTime">
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
  @if (showSearchbar()) {
    <ion-toolbar color="primary">
      <ion-searchbar
        [(ngModel)]="search"
        (keyup.enter)="closeKeyboard()"
        show-cancel-button="never"
        [placeholder]="'CR.RECHERCHE_CR' | translate"
        (ionInput)="onSearchInput()"
        (ionCancel)="onSearchCancel()"
      ></ion-searchbar>
    </ion-toolbar>
  }
</ion-header>
<ion-content>
  <ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-list class="cr-list-container">
    @if (showSearchbar()) {
      <div>
        <div class="empty" *ngIf="cr_list_user_filtered.length === 0">
          <ion-icon name="copy-outline"></ion-icon>
          @if (!loading()) {
            @if (search === '') {
              <span>{{ 'CR.AUCUN_CR_3' | translate }}</span>
            } @else {
              <span>{{ 'CR.AUCUN_CR_2' | translate }} "{{ search }}"</span>
            }
          }
        </div>
        @for (cr of cr_list_user_filtered; track cr_list_user_filtered; let i = $index) {
          @if (cr.type !== 'cr-activite-interne') {
            <ion-item (click)="goToCrDetails(cr)" no-lines>
              <cr-list-item [cr]="cr"></cr-list-item>
            </ion-item>
          } @else {
            <ion-item class="cr_ion_item" lines="none">
              <cr-activite-interne-item
                item-content
                *ngIf="cr.type === 'cr-activite-interne'"
                [cr]="$any(cr)"
                (click)="goToCrActiviteInterneDetails($any(cr))"
              ></cr-activite-interne-item>
            </ion-item>
          }
        }
      </div>
    } @else {
      <div>
        <time-counter-tile
          *ngIf="showSyntheseDesHeures"
          [disabled]="!isConnected"
          title="{{ 'TIME_COUNTER.TITLE' | translate }}"
          [minutesDone]="minutesDoneToDisplay"
          [maxMinutes]="maxMinutesToDisplay"
          [gaugeData]="gaugeData"
          [displayDetails]="showSyntheseDesHeuresDetails"
          (displayDetailsChange)="showSyntheseDesHeuresDetails = $event"
        ></time-counter-tile>
        <accordion title="{{ ' CR Saisis' | translate }}" color="primary">
          <cr-list-vue-jour
            *ngIf="segments === 'jour' && (cr_list_user_filtered.length > 0 || cr_en_cours_denvoi.length > 0)"
            [isDraftCrDeletionModeActive]="isDraftCrDeletionModeActive"
            [crEnCoursDenvoiFiltered]="cr_en_cours_denvoi_filtered"
            [crListUserFiltered]="cr_list_user_filtered"
            (crEmitter)="goToCrDetails($event)"
            (crActiviteInterneEmitter)="goToCrActiviteInterneDetails($event)"
          ></cr-list-vue-jour>
          <cr-list-vue-semaine
            *ngIf="segments === 'semaine' && cr_list_user_filtered.length > 0"
            [isDraftCrDeletionModeActive]="isDraftCrDeletionModeActive"
            [crEnCoursDenvoiFiltered]="cr_en_cours_denvoi_filtered"
            [crListUserFiltered]="cr_list_user_filtered"
            [startOfWeek]="startOfWeek"
            (crEmitter)="goToCrDetails($event)"
            (crActiviteInterneEmitter)="goToCrActiviteInterneDetails($event)"
          ></cr-list-vue-semaine>

          @if (loading()) {
            <div class="empty relative" *ngIf="cr_list_user.length === 0">
              <div>
                <ion-icon name="sync" class="infinite-rotate"></ion-icon>
                <span>{{ 'CR.LOADING' | translate }}</span>
              </div>
            </div>
          } @else {
            <div
              class="empty relative"
              *ngIf="cr_list_user_filtered.length === 0 && cr_en_cours_denvoi_filtered.length === 0"
            >
              <ion-icon name="copy-outline"></ion-icon>
              <span *ngIf="search === ''">{{ 'CR.AUCUN_CR_4' | translate }}</span>
            </div>
          }
        </accordion>
        <div *ngIf="cr_list_brouillon && cr_list_brouillon.length > 0">
          <ion-list-header class="brouillon-title">
            CR Brouillon
            @if (loading_brouillon()) {
              <ion-icon name="sync" class="infinite-rotate"></ion-icon>
            }
            <ion-button fill="clear" class="button_cancel" (click)="toggleCancel()" *ngIf="isDraftCrDeletionModeActive">
              <span>Annuler</span>
            </ion-button>
            <ion-button
              fill="clear"
              class="button_delete"
              (click)="toggleDelete()"
              [disabled]="isButtonDeleteDisabled()"
            >
              <span><ion-icon name="trash" [color]="isButtonDeleteDisabled() ? 'dark' : 'white'"></ion-icon></span>
            </ion-button>
          </ion-list-header>
          @for (cr of cr_list_brouillon; track cr_list_brouillon; let i = $index) {
            <ion-item class="cr_ion_item" (click)="goToCrDetails(cr)" lines="none">
              <input
                slot="start"
                type="checkbox"
                *ngIf="isDraftCrDeletionModeActive"
                (click)="toogleCheckbox(cr)"
                [checked]="isCrInDeletionList(cr)"
              />
              <cr-brouillon-list-item
                [class.cr_list_item_disabled]="isDraftCrDeletionModeActive"
                item-content
                [brouillon]="cr"
              ></cr-brouillon-list-item>
            </ion-item>
          }
        </div>
      </div>
    }
  </ion-list>
</ion-content>
<ion-footer>
  <ion-button
    class="select-all-draft-button"
    *ngIf="isDraftCrDeletionModeActive && draftCrToDeleteList.length !== cr_list_brouillon.length"
    (click)="selectAllDraft()"
  >
    <span>{{ 'CR.TOUT_SELECTIONNER' | translate }}</span>
  </ion-button>
</ion-footer>
